<template>
  <td>
    <div class="google">
      <v-checkbox
        color="primary"
        class="mt-0"
        hide-details
        style="display: inline-block;"
        v-model="googleForm.enabled"
        label="Google"
        @change="hide = (googleForm.enabled ? !googleForm.enabled : hide)"
      />
      <v-icon style="cursor-pointer" @click="hide = !hide">{{ hide ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
    </div>
    <div v-show="!hide" class="google-security">
      <v-form
        ref="googleForm"
        v-model="googleForm.valid"
        lazy-validation
      >
        <v-file-input class="select-field"
          accept="application/JSON"
          label="Select File"
          v-model="googleForm.data"
          @change="$emit('onFileChange', $event)"
          required
          solo
          :rules="[rules.required]"
        ></v-file-input>
        <template v-for="(gJson, index) in googleJson">
          <v-textarea
            v-if="index !== 'user_id'"
            filled
            :label="formatExtractedJsonIndex(index)"
            :value="gJson"
            disabled
            auto-grow
            rows="1"
            class="mb-0"
            :key="'google-'+index"
          ></v-textarea>
        </template>
        <v-textarea
          v-if="googleJson"
          filled
          label="User ID"
          v-model="userId"
          auto-grow
          rows="1"
          class="mb-0"
          key="google-user-id"
          required
          :rules="[rules.required, rules.email]"
        ></v-textarea>
      </v-form>
    </div>
  </td>
</template>
<script>
import { validateEmail } from '@/utils/main_helper'

export default {
  name: 'GoogleConfigureForm',
  props: ['google', 'googleJson'],
  created () {
    this.googleForm = this.google
  },
  data () {
    return {
      googleForm: null,
      hide: true,
      rules: {
        required: v => !!v || 'Required.',
        email: v => validateEmail(v) || 'User ID must be a valid e-mail address.'
      }
    }
  },
  computed: {
    userId: {
      get () {
        return this?.googleJson?.user_id
      },
      set (val) {
        this.googleJson.user_id = val
      }
    }
  },
  methods: {
    formatExtractedJsonIndex (index) {
      return index.replace(/_/g, ' ').replace(/-/g, ' ')
    }
  }
}
</script>
<style lang="scss" scoped>
  .google {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>
